import { setCookie } from 'cookies-next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import {
  SELECTED_PROJECT_COOKIE_KEY,
  useSelectedProjectStore
} from '@/components/entities/common/model/selected-project.store'
import { isProjectIdValid } from '@/utils/string-formatting'

export const useProjectId = () => {
  const router = useRouter()
  const { selectedProjectId, setSelectedProjectId } = useSelectedProjectStore()

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      const parsedUrl = new URL(url, window.location.origin)
      const projectId = parsedUrl.searchParams.get('projectId')

      if (
        isProjectIdValid(projectId) &&
        projectId &&
        projectId !== selectedProjectId
      ) {
        setCookie(SELECTED_PROJECT_COOKIE_KEY, projectId)
        setSelectedProjectId(projectId)

        parsedUrl.searchParams.delete('projectId')
        const newUrl = parsedUrl.pathname + parsedUrl.search

        router.replace(newUrl, undefined, { shallow: true })
      }
    }

    router.events.on('routeChangeComplete', handleRouteChange)

    handleRouteChange(window.location.href)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router, selectedProjectId, setSelectedProjectId])
}
